var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcMenuToggle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/collapse for menu",
    clipPath: "url(#clip0_1_5148)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.26918 12.668C6.00107 12.9439 5.55802 12.9439 5.2899 12.668C5.03267 12.4032 5.03244 11.982 5.28938 11.717L7.5811 9.35325C7.76913 9.15932 7.76913 8.8511 7.5811 8.65716L5.28938 6.29346C5.03244 6.02844 5.03267 5.6072 5.2899 5.34246C5.55802 5.06653 6.00107 5.06653 6.26918 5.34246L9.48956 8.65677C9.6781 8.85081 9.6781 9.15961 9.48956 9.35364L6.26918 12.668Z",
    fill: "#79808A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.58015 12.6461C9.31288 12.9212 8.87121 12.9212 8.60393 12.6461C8.34632 12.381 8.34745 11.9587 8.60647 11.6949L10.9036 9.35592C11.096 9.15998 11.0944 8.84553 10.9 8.65158L8.61466 6.37195C8.34811 6.10606 8.33394 5.67884 8.5823 5.39587C8.85703 5.08286 9.34031 5.07061 9.63054 5.36931L12.8021 8.63334C12.9906 8.82737 12.9906 9.13617 12.8021 9.33021L9.58015 12.6461Z",
    fill: "#79808A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_5148"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.6667,
    height: 16.6667,
    fill: "white",
    transform: "matrix(1 0 0 -1 0.664062 17.3359)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMenuToggle);
export default __webpack_public_path__ + "static/media/ic_menu_toggle.02e68b1c90576e085dbd5e7752a5853a.svg";
export { ForwardRef as ReactComponent };